module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-row', {
    staticClass: "mb20"
  }, [_c('h1', [_vm._v("今日实时数据 "), _c('span', [_vm._v(_vm._s(_vm.hourData.updateTime) + "更新")])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("营业额")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                        ¥" + _vm._s(_vm.hourData.saleAmount)), (_vm.hourData.saleAmountDecimal) ? _c('span', {
    staticClass: "f20"
  }, [_vm._v("." + _vm._s(_vm.hourData.saleAmountDecimal))]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("收入")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                        ¥" + _vm._s(_vm.hourData.incomeAmount)), (_vm.hourData.incomeAmountDecimal) ? _c('span', {
    staticClass: "f20"
  }, [_vm._v("." + _vm._s(_vm.hourData.incomeAmountDecimal))]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("订单总数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hourData.totalOrderCount))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("外卖订单")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hourData.takeawayOrderedCount))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("自提订单")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hourData.pickUpOrderCount))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("堂食订单")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hourData.dineInOrderCount))])])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("下单人数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hourData.orderCount))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("下单转化率")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                        " + _vm._s(_vm.hourData.orderCountPercentage == 0 ? 0 : ((_vm.hourData.orderCountPercentage) * 100).toFixed(2) + '%') + "\n                    ")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("曝光人数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hourData.viewCount))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("入店人数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.hourData.enterCount))])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pt20 pb10"
  }, [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("入店转化率")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                        " + _vm._s(_vm.hourData.viewShopPercentage == 0 ? 0 : ((_vm.hourData.viewShopPercentage) * 100).toFixed(2) + '%') + "\n                    ")])])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "mb20"
  }, [_c('h1', [_vm._v("历史数据概览")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('el-row', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "pl24 pb10 pt10"
  }, [_vm._l((_vm.timeTabList), function(item, index) {
    return _c('span', {
      staticClass: "tag-name cursor c6",
      class: {
        'checked': item.checked
      },
      on: {
        "click": function($event) {
          return _vm.getHistoryData(item.id, index)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "right",
      "width": "300",
      "trigger": "click"
    },
    model: {
      value: (_vm.popoverVisible),
      callback: function($$v) {
        _vm.popoverVisible = $$v
      },
      expression: "popoverVisible"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "month",
      "size": "small",
      "value-format": "yyyy-MM",
      "placeholder": "选择月"
    },
    model: {
      value: (_vm.selectMonth),
      callback: function($$v) {
        _vm.selectMonth = $$v
      },
      expression: "selectMonth"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.getMonth()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('span', {
    staticClass: "tag-name c6 cursor",
    class: {
      'checked': _vm.isMonthChecked
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("按月")])], 1), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "right",
      "width": "420",
      "trigger": "click"
    },
    model: {
      value: (_vm.popoverVisible1),
      callback: function($$v) {
        _vm.popoverVisible1 = $$v
      },
      expression: "popoverVisible1"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.selectDate),
      callback: function($$v) {
        _vm.selectDate = $$v
      },
      expression: "selectDate"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.getDate()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('span', {
    staticClass: "tag-name c6 cursor",
    class: {
      'checked': _vm.isDateChecked
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v("自定义")])], 1)], 2)])]), _vm._v(" "), _c('el-row', {
    staticClass: "mb20"
  }, [_c('span', {
    staticClass: "pl24 c6"
  }, [_vm._v("已选时间：" + _vm._s(_vm.startDate) + "至" + _vm._s(_vm.endDate))])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-name"
  }, [_vm._v("营业分析")]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("营业额")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            ¥" + _vm._s(_vm.businessDetail.saleAmount)), (_vm.businessDetail.saleAmountDecimal) ? _c('span', {
    staticClass: "f20"
  }, [_vm._v("." + _vm._s(_vm.businessDetail.saleAmountDecimal))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.saleAmount, _vm.businessDetail.saleAmountCompare)) + "\n                            "), ((_vm.businessDetail.saleAmount) - (_vm.businessDetail.saleAmountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.saleAmount) - (_vm.businessDetail.saleAmountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("收入")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            ¥" + _vm._s(_vm.businessDetail.incomeAmount)), (_vm.businessDetail.incomeAmountDecimal) ? _c('span', {
    staticClass: "f20"
  }, [_vm._v("." + _vm._s(_vm.businessDetail.incomeAmountDecimal))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.incomeAmount, _vm.businessDetail.incomeAmountCompare)) + "\n                            "), ((_vm.businessDetail.incomeAmount) - (_vm.businessDetail.incomeAmountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.incomeAmount) - (_vm.businessDetail.incomeAmountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("客单价")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            ¥" + _vm._s(_vm.businessDetail.averageSinglePerson)), (_vm.businessDetail.averageSinglePersonDecimal) ? _c('span', {
    staticClass: "f20"
  }, [_vm._v("." + _vm._s(_vm.businessDetail.averageSinglePersonDecimal))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.averageSinglePerson, _vm.businessDetail.averageSinglePersonCompare)) + "\n                            "), ((_vm.businessDetail.averageSinglePerson) - (_vm.businessDetail.averageSinglePersonCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.averageSinglePerson) - (_vm.businessDetail.averageSinglePersonCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("订单总数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.businessDetail.totalOrderCount))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.totalOrderCount, _vm.businessDetail.totalOrderCountCompare)) + "\n                            "), ((_vm.businessDetail.totalOrderCount) - (_vm.businessDetail.totalOrderCountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.totalOrderCount) - (_vm.businessDetail.totalOrderCountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("外卖订单")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.businessDetail.takeawayOrderedCount))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.takeawayOrderedCount, _vm.businessDetail.takeawayOrderedCountCompare)) + "\n                            "), ((_vm.businessDetail.takeawayOrderedCount) - (_vm.businessDetail.takeawayOrderedCountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.takeawayOrderedCount) - (_vm.businessDetail.takeawayOrderedCountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("自提订单")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.businessDetail.pickUpOrderCount))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.pickUpOrderCount, _vm.businessDetail.pickUpOrderCountCompare)) + "\n                            "), ((_vm.businessDetail.pickUpOrderCount) - (_vm.businessDetail.pickUpOrderCountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }) : ((_vm.businessDetail.pickUpOrderCount) - (_vm.businessDetail.pickUpOrderCountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("堂食订单")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.businessDetail.dineInOrderCount))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.dineInOrderCount, _vm.businessDetail.dineInOrderCountCompare)) + "\n                            "), ((_vm.businessDetail.dineInOrderCount) - (_vm.businessDetail.dineInOrderCountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.dineInOrderCount) - (_vm.businessDetail.dineInOrderCountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])])])])]), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-name"
  }, [_vm._v("顾客分析")]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("新客人数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.businessDetail.newCustomerCount))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.newCustomerCount, _vm.businessDetail.newCustomerCountCompare)) + "\n                            "), ((_vm.businessDetail.newCustomerCount) - (_vm.businessDetail.newCustomerCountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.newCustomerCount) - (_vm.businessDetail.newCustomerCountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("新客占比")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.businessDetail.newCustomerPercentage == 0 ? 0 : ((_vm.businessDetail.newCustomerPercentage) * 100).toFixed(2) + '%'))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(((_vm.getValue(_vm.businessDetail.newCustomerPercentage, _vm.businessDetail.newCustomerPercentageCompare)) * 100).toFixed(0)) + "%\n                            "), ((_vm.businessDetail.newCustomerPercentage) - (_vm.businessDetail.newCustomerPercentageCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.newCustomerPercentage) - (_vm.businessDetail.newCustomerPercentageCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("复购人数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.businessDetail.repurchaseCount))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.repurchaseCount, _vm.businessDetail.repurchaseCountCompare)) + "\n                            "), ((_vm.businessDetail.repurchaseCount) - (_vm.businessDetail.repurchaseCountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.repurchaseCount) - (_vm.businessDetail.repurchaseCountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("复购率")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.businessDetail.repurchasePercentage == 0 ? 0 : ((_vm.businessDetail.repurchasePercentage) * 100).toFixed(2) + '%'))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(((_vm.getValue(_vm.businessDetail.repurchasePercentage, _vm.businessDetail.repurchasePercentageCompare)) * 100).toFixed(0)) + "%\n                            "), ((_vm.businessDetail.repurchasePercentage) - (_vm.businessDetail.repurchasePercentageCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.businessDetail.repurchasePercentage) - (_vm.businessDetail.repurchasePercentageCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("总下单人数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.businessDetail.totalPurchaseCount))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                            " + _vm._s(_vm.tabName) + "\n                            "), _vm._v("\n                            " + _vm._s(_vm.getValue(_vm.businessDetail.totalPurchaseCount, _vm.businessDetail.totalPurchaseCountCompare)) + "\n                            "), ((_vm.businessDetail.totalPurchaseCount) - (_vm.businessDetail.totalPurchaseCountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }) : ((_vm.businessDetail.totalPurchaseCount) - (_vm.businessDetail.totalPurchaseCountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])])])])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "min-height": "500px"
    }
  }, [_c('div', {
    staticClass: "card-name"
  }, [_vm._v("流量分析")]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("曝光人数")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.viewDetail.viewCount))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                                " + _vm._s(_vm.tabName) + "\n                                " + _vm._s(_vm.getValue(_vm.viewDetail.viewCount, _vm.viewDetail.viewCountCompare)) + "\n                                "), ((_vm.viewDetail.viewCount) - (_vm.viewDetail.viewCountCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.viewDetail.viewCount) - (_vm.viewDetail.viewCountCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("入店转化率")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.viewDetail.convertInShop == 0 ? 0 : ((_vm.viewDetail.convertInShop) * 100).toFixed(2) + '%'))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                                " + _vm._s(_vm.tabName) + "\n                                "), _vm._v("\n                                " + _vm._s(((_vm.getValue(_vm.viewDetail.convertInShop, _vm.viewDetail.convertInShopCompare)) * 100).toFixed(0)) + "%\n                                "), ((_vm.viewDetail.convertInShop) - (_vm.viewDetail.convertInShopCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.viewDetail.convertInShop) - (_vm.viewDetail.convertInShopCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "tag-name"
  }, [_vm._v("下单转化率")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.viewDetail.convertInOrder == 0 ? 0 : ((_vm.viewDetail.convertInOrder) * 100).toFixed(2) + '%'))]), _vm._v(" "), _c('div', {
    staticClass: "c7"
  }, [_vm._v("\n                                " + _vm._s(_vm.tabName) + "\n                                "), _vm._v(" "), ((_vm.viewDetail.convertInOrder) - (_vm.viewDetail.convertInOrderCompare) != 0) ? _c('span', [_vm._v(_vm._s(((_vm.getValue(_vm.viewDetail.convertInOrder, _vm.viewDetail.convertInOrderCompare)) * 100).toFixed(0)) + "%")]) : _vm._e(), _vm._v(" "), ((_vm.viewDetail.convertInOrder) - (_vm.viewDetail.convertInOrderCompare) > 0) ? _c('span', {
    staticClass: "arrow-up"
  }, [_vm._v("️")]) : ((_vm.viewDetail.convertInOrder) - (_vm.viewDetail.convertInOrderCompare) < 0) ? _c('span', {
    staticClass: "arrow-down"
  }, [_vm._v("️")]) : _c('span', [_vm._v("持平")])])])]), _vm._v(" "), _c('el-table', {
    staticClass: "bi-table",
    staticStyle: {
      "width": "100%",
      "padding": "0 24px 24px"
    },
    attrs: {
      "data": _vm.viewDetail.viewCountDetail
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "clientType",
      "label": "客户端类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.clientType == 0) ? _c('span', [_vm._v("APP")]) : (scope.row.clientType == 1) ? _c('span', [_vm._v("微信公众号")]) : (scope.row.clientType == 2) ? _c('span', [_vm._v("微信小程序")]) : (scope.row.clientType == 3) ? _c('span', [_vm._v("支付宝小程序")]) : (scope.row.clientType == 999) ? _c('span', [_vm._v("其他")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "viewCount",
      "width": "100",
      "label": "曝光人数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "enterCount",
      "label": "入店人数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "viewShopPercentage",
      "label": "入店转化率"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.viewShopPercentage > 0) ? _c('span', [_vm._v(_vm._s(((scope.row.viewShopPercentage) * 100).toFixed(2)) + "%")]) : _c('span', [_vm._v(_vm._s(scope.row.viewShopPercentage))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "orderCount",
      "label": "下单人数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderCountPercentage",
      "label": "下单转化率"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.orderCountPercentage > 0) ? _c('span', [_vm._v(_vm._s(((scope.row.orderCountPercentage) * 100).toFixed(2)) + "%")]) : _c('span', [_vm._v(_vm._s(scope.row.orderCountPercentage))])]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "min-height": "500px"
    }
  }, [_c('div', {
    staticClass: "card-name"
  }, [_vm._v("学校排名")]), _vm._v(" "), _c('el-table', {
    staticClass: "bi-table table2",
    staticStyle: {
      "width": "100%",
      "padding": "24px 24px 0 24px",
      "height": "430px"
    },
    attrs: {
      "data": _vm.schoolRanking.schoolRankingInfos
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "60",
      "prop": "ranking",
      "label": "排名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "schoolName",
      "label": "学校名称",
      "show-overflow-tooltip": true
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "prop": "orderCount",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "prop": "saleAmount",
      "show-overflow-tooltip": true,
      "label": "营业额"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "bi-pager",
    attrs: {
      "current-page": _vm.pageNo,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e681139"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/headOffice/home.vue
// module id = 845
// module chunks = 0